import TableText from "@/components/table/TableText";
import { calculation, numConvert } from "@/method";
import detaultData from './detaultData';
import _ from 'lodash';
import moment from "moment";
import React from "react";

const listName = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export default (data, { date }) => {
    const month = moment(date).format('M');
    const user = JSON.parse(sessionStorage.getItem('user') || "{}");
    const hotelData = detaultData.find(x => x.id == user.comid);

    listName.forEach(name => {
        if (hotelData) {
            data[7][name] = hotelData.laxin || 0;
            data[17][name] = hotelData.income || 0;
        }

        data[9][name] = calculation(data[8][name], data[7][name], 4);

        data[19][name] = calculation(data[18][name], data[17][name], 4);
    });
    data.forEach((item, i) => {
        data[i].total = listName.reduce((a, b, index) => {
            if (index < month) a += numConvert(data[i][b]);
            return a
        }, 0).toFixed(2);
    });
    data[9].total = calculation(data[8].total, data[7].total, 4);
    data[19].total = calculation(data[18].total, data[17].total, 4);
    return data
}

export const fillData = (data, { e2_1, e2_2, e4_1_1, e5_1, last }) => {
    // 2.1数据填充至实际客房数
    listName.forEach((name, index) => {
        data[1][name] = _.get(e2_1, `2.${name}`, 0);
        data[3][name] = _.get(e2_2, `2.${name}`, 0);
        // 餐饮人数和收益
        data[2][name] = _.get(e5_1.find(x => x.month == ~~(index + 1)), `covers`, 0);
        data[4][name] = _.get(e5_1.find(x => x.month == ~~(index + 1)), `m_covers`, 0);
        data[11][name] = _.get(e4_1_1, `${index * 3 + 1}.best_rev`, 0);
        data[13][name] = _.get(e4_1_1, `${index * 3}.best_rev`, 0);
        data[12][name] = _.get(e5_1.find(x => x.month == ~~(index + 1)), `REV`, 0);
        data[14][name] = _.get(e5_1.find(x => x.month == ~~(index + 1)), `m_REV`, 0);
    });
    // 上个月数据填充
    if (last && last.length && !_.get(data, '0.id')) { 
        listName.forEach((name, index) => {
            data[8][name] = last[8][name];
            data[18][name] = last[18][name];
        })
    }
    return data;
}

const totalIndex = [0, 10];
const percentIndex = [9, 19];
const hideIndex = [5, 6, 15, 16];
export const columns = (onChange, print, date) => {
    const month = moment(date).format('M');
    return [
        {
            title: '名称',
            dataIndex: 'name',
            key: 'name',
            align: "center",
            fixed: "left",
            width: 300,
            render: (text, record, index) => {
                if (hideIndex.includes(index)) {
                    return {
                        props: {
                            colSpan: 0
                        },
                    }
                }
                const props = {
                    text,
                    index,
                    type: 'text',
                    name: "name",
                    onChange,
                    totalIndex,
                };
                return <TableText data={props} />
            }
        },
        ...["Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"].map((name, _M) => {
                return {
                    title: name,
                    dataIndex: name,
                    key: name,
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = [name];
                        if (hideIndex.includes(index)) {
                            return {
                                props: {
                                    colSpan: 0
                                },
                            }
                        }
                        const props = {
                            text,
                            index,
                            type: percentIndex.includes(index) ? 'percent' : [8, 18].includes(index) ? 'inputNumber' : 'number',
                            name,
                            onChange,
                            totalIndex,
                        };
                        props.compared = {
                            title,
                            record,
                            sqlName: "_12"
                        }

                        if (index == 0) {
                            return <TableText data={{ ...props, type: "textcenter", text: month > _M ? 'Actual' : "Forecast", compared: false }} />
                        }

                        if (index == 10) return {
                            props: {
                                colSpan: name == 'Jan' ? 13 : 0
                            },
                            children: name == 'Jan' ? <TableText data={{ ...props, type: 'text', text: " ", compared: false }} /> : null
                        }
                        return <TableText data={props} />
                    }
                }
            })
        , {
            title: "YTD",
            dataIndex: "total",
            key: "total",
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = ["YTD"];
                const props = {
                    text,
                    index,
                    type: percentIndex.includes(index) ? 'percent' : 'number',
                    name: "total",
                    onChange,
                    totalIndex,
                };
                if (hideIndex.includes(index)) {
                    return {
                        props: {
                            colSpan: 0
                        },
                    }
                }
                props.compared = {
                    title,
                    record,
                    sqlName: "_12"
                }
                if (index == 0) {
                    return <TableText data={{ ...props, type: "text", text: " ", compared: false }
                    } />
                }
                if (index == 10) return {
                    props: {
                        colSpan: 0
                    },
                    children: null
                }
                return <TableText data={props} />
            }
        }
    ]
}



// WEBPACK FOOTER //
// ./src/components/table/12/compute.js